import s from './NotFound.scss'

const NotFound = () => (
  <section className={s.container}>
    <span className={s.text}>404</span>
  </section>
)

export default NotFound
